import { createSlice } from "@reduxjs/toolkit";

const userPermissionsSlice = createSlice({
  name: "userPermissions",
  initialState: {},
  reducers: {
    setUserPermissions: (_state, action) => action.payload,
  },
});

const portalSettingInfoSlice = createSlice({
  name: "portalSettingInfo",
  initialState: {},
  reducers: {
    setPortalSettingInfo: (_state, action) => action.payload,
  },
});

export const { setUserPermissions } = userPermissionsSlice.actions;
export const { setPortalSettingInfo } = portalSettingInfoSlice.actions;

export const userPermissions = userPermissionsSlice.reducer;
export const portalSettingInfo = portalSettingInfoSlice.reducer;
